import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Select from "react-select";
import { getAllCompanies } from "../../../redux/companySlice/companySlice";

export default function CompanySelect({ setSelectedCompany, selectedCompany }) {
  const location = useLocation();
  const dispatch = useDispatch();
  const { allCompanies } = useSelector((state) => state.company);
  const [allCompaniesData, setAllCompaniesData] = useState([]);
  useEffect(() => {
    dispatch(getAllCompanies());
  }, []);
  useEffect(() => {
    setAllCompaniesData(allCompanies);
  }, [allCompanies]);

  let companyOptions =
    allCompaniesData &&
    allCompaniesData.length > 0 &&
    allCompaniesData?.map((company) => ({
      value: company.id,
      label: company.name,
    }));

  const handleCompanyChange = (selectedOption) => {
    setSelectedCompany(selectedOption);
  };

  const isAddContractPage = location.pathname.endsWith("/addContract");

  return (
    <div>
      <label htmlFor="companySelect"> {isAddContractPage ? "اختر الشركة" : "تابع لشركة"} </label>
      <Select
        options={companyOptions ? companyOptions : []}
        onChange={handleCompanyChange}
        placeholder="اختر الشركة"
        value={selectedCompany}
        isSearchable
        menuPortalTarget={document.body} 
        classNames={{
          control: (state) => (state.isFocused ? "selectSearchFocus" : "selectSearch"),
        }}
      />
    </div>
  );
}
